export default __webpack_public_path__ + "static/media/HEADERS-Vimepay.e9e62369.png";